.card {
  background-color: var(--tuna-palette-background-paper);
  color: var(--tuna-palette-text-primary);
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  /* Flat card — boundary is carried by the 1px divider border alone. */
  padding: var(--tuna-spacing-2);
  width: 320px;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.identityRow {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.identityName {
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  flex-grow: 1;
}

.notes {
  font-family: var(--tuna-font-monospace, monospace);
  color: var(--tuna-palette-text-secondary);
}

.rationale {
  color: var(--tuna-palette-text-secondary);
  font-size: 0.875rem;
}

/* Lexicon-driven borrowed-chord line (S3b). Same .rationale styling but
 * uses an italic to distinguish the level-gated theory cue from the
 * analyzer-emitted rationale above it. Sized identically so the two
 * lines read as a coherent paragraph at all theory levels. */
.borrowedLine {
  font-style: italic;
}

.body {
  display: flex;
  flex-direction: row;
  gap: var(--tuna-spacing-2);
  align-items: flex-start;
  margin-top: var(--tuna-spacing-1);
}

.diagramSlot {
  flex: 0 0 auto;
  width: 140px;
}

.suggestions {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.suggestionsHeading {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--tuna-palette-text-secondary);
}

.suggestionsRow {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-1);
}

.suggestionChip {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--tuna-spacing-1);
  background-color: transparent;
  border: 1px solid var(--tuna-palette-divider);
  border-radius: var(--tuna-shape-borderRadius);
  cursor: pointer;
  min-height: 44px;
  min-width: 64px;
  font: inherit;
  color: inherit;
  transition: background-color 150ms ease;
}

.suggestionChip:hover {
  background-color: var(--tuna-palette-action-hover);
}

.suggestionChip:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 1px;
}

.suggestionChipName {
  font-weight: 600;
}

.suggestionChipFunction {
  font-size: 0.75rem;
  color: var(--tuna-palette-text-secondary);
}

.footerNote {
  color: var(--tuna-palette-text-secondary);
  font-size: 0.875rem;
  font-style: italic;
}

@media (max-width: 480px) {
  .card {
    width: calc(100vw - 16px);
    max-width: none;
  }
  .body {
    flex-direction: column;
  }
  .diagramSlot {
    width: 100%;
    max-width: 180px;
  }
  .identityRow {
    flex-wrap: wrap;
  }
}
